export const EXIT_LOCK_WHALE_RETENTION_THRESHOLD = 50_000; // 50,000 iUSD
export const EXIT_LOCK_CONTACT = {
    name: "Val",
    title: "Growth Lead",
    href: "https://t.me/valbpereira",
};
